import { $authHost } from "../../http";
import { 
    GOVERNMENT_STANDARD_GET_REQUEST, GOVERNMENT_STANDARD_GET_SUCCESS, GOVERNMENT_STANDARD_GET_ERROR, 
    GOVERNMENT_STANDARD_GET_BY_KEY_REQUEST, GOVERNMENT_STANDARD_GET_BY_KEY_SUCCESS, GOVERNMENT_STANDARD_GET_BY_KEY_ERROR, 
    GOVERNMENT_STANDARD_ADD_REQUEST, GOVERNMENT_STANDARD_ADD_SUCCESS, GOVERNMENT_STANDARD_ADD_ERROR, 
    GOVERNMENT_STANDARD_EDIT_REQUEST, GOVERNMENT_STANDARD_EDIT_SUCCESS, GOVERNMENT_STANDARD_EDIT_ERROR, 
    GOVERNMENT_STANDARD_DELETE_REQUEST, GOVERNMENT_STANDARD_DELETE_SUCCESS, GOVERNMENT_STANDARD_DELETE_ERROR
} from "../constants/governmentStandardConstants";

export const getGovernmentStandards = (args) => async (dispatch) => {
    try {
        dispatch({
            type: GOVERNMENT_STANDARD_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/governmentStandard/query",
            args || {},
            config,
        );
        dispatch({
            type: GOVERNMENT_STANDARD_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: GOVERNMENT_STANDARD_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getGovernmentStandardByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: GOVERNMENT_STANDARD_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/governmentStandard/${id}`,
        );
        dispatch({
            type: GOVERNMENT_STANDARD_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: GOVERNMENT_STANDARD_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addGovernmentStandard = ({ name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: GOVERNMENT_STANDARD_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/governmentStandard",
            { name, code, description },
            config,
        );
        dispatch(getGovernmentStandards(queryArgs || {}));
        dispatch({
            type: GOVERNMENT_STANDARD_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: GOVERNMENT_STANDARD_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editGovernmentStandard = ({ id, name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: GOVERNMENT_STANDARD_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/governmentStandard",
            { id, name, code, description },
            config,
        );
        dispatch(getGovernmentStandards(queryArgs || {}));
        dispatch({
            type: GOVERNMENT_STANDARD_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: GOVERNMENT_STANDARD_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteGovernmentStandard = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: GOVERNMENT_STANDARD_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/governmentStandard",
            { data: { id } },
            config,
        );
        dispatch(getGovernmentStandards(queryArgs || {}));
        dispatch({
            type: GOVERNMENT_STANDARD_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: GOVERNMENT_STANDARD_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

